import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";

export const DropdownTrigger = styled(Dropdown.Trigger)`
  color: var(--mode-vector-neutral-strong);
`;

export const DropdownContent = styled(Dropdown.Content)`
  min-width: unset;
`;
